module.exports = __webpack_public_path__ + "img/inc-light-icon.e1321902.svg";